// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-avatar {
  flex: none;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  line-height: normal;
  overflow: hidden;
  position: relative;
  text-align: center;
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: width, height;
  vertical-align: middle;
}
:where(.vuetify-styles) .v-avatar.v-avatar--size-x-small {
  --v-avatar-height: 24px;
}
:where(.vuetify-styles) .v-avatar.v-avatar--size-small {
  --v-avatar-height: 32px;
}
:where(.vuetify-styles) .v-avatar.v-avatar--size-default {
  --v-avatar-height: 40px;
}
:where(.vuetify-styles) .v-avatar.v-avatar--size-large {
  --v-avatar-height: 48px;
}
:where(.vuetify-styles) .v-avatar.v-avatar--size-x-large {
  --v-avatar-height: 56px;
}
:where(.vuetify-styles) .v-avatar.v-avatar--density-default {
  height: calc(var(--v-avatar-height) + 0px);
  width: calc(var(--v-avatar-height) + 0px);
}
:where(.vuetify-styles) .v-avatar.v-avatar--density-comfortable {
  height: calc(var(--v-avatar-height) + -4px);
  width: calc(var(--v-avatar-height) + -4px);
}
:where(.vuetify-styles) .v-avatar.v-avatar--density-compact {
  height: calc(var(--v-avatar-height) + -8px);
  width: calc(var(--v-avatar-height) + -8px);
}
:where(.vuetify-styles) .v-avatar {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0;
}
:where(.vuetify-styles) .v-avatar--border {
  border-width: thin;
  box-shadow: none;
}
:where(.vuetify-styles) .v-avatar {
  border-radius: 50%;
}
:where(.vuetify-styles) .v-avatar--variant-plain, :where(.vuetify-styles) .v-avatar--variant-outlined, :where(.vuetify-styles) .v-avatar--variant-text, :where(.vuetify-styles) .v-avatar--variant-tonal {
  background: transparent;
  color: inherit;
}
:where(.vuetify-styles) .v-avatar--variant-plain {
  opacity: 0.62;
}
:where(.vuetify-styles) .v-avatar--variant-plain:focus, :where(.vuetify-styles) .v-avatar--variant-plain:hover {
  opacity: 1;
}
:where(.vuetify-styles) .v-avatar--variant-plain .v-avatar__overlay {
  display: none;
}
:where(.vuetify-styles) .v-avatar--variant-elevated, :where(.vuetify-styles) .v-avatar--variant-flat {
  background: rgb(var(--v-theme-surface));
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
}
:where(.vuetify-styles) .v-avatar--variant-elevated {
  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-avatar--variant-flat {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-avatar--variant-outlined {
  border: thin solid currentColor;
}
:where(.vuetify-styles) .v-avatar--variant-text .v-avatar__overlay {
  background: currentColor;
}
:where(.vuetify-styles) .v-avatar--variant-tonal .v-avatar__underlay {
  background: currentColor;
  opacity: var(--v-activated-opacity);
  border-radius: inherit;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
}
:where(.vuetify-styles) .v-avatar .v-avatar__underlay {
  position: absolute;
}
:where(.vuetify-styles) .v-avatar--rounded {
  border-radius: 4px;
}
:where(.vuetify-styles) .v-avatar--start {
  margin-inline-end: 8px;
}
:where(.vuetify-styles) .v-avatar--end {
  margin-inline-start: 8px;
}
:where(.vuetify-styles) .v-avatar .v-img {
  height: 100%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VAvatar/VAvatar.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,6CAA6C;EAC7C,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0CAA0C;EAC1C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,0CAA0C;AAC5C;AACA;EACE,2CAA2C;EAC3C,0CAA0C;AAC5C;AACA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,uCAAuC;EACvC,wEAAwE;AAC1E;AACA;EACE,uOAAuO;AACzO;AACA;EACE,sOAAsO;AACxO;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,sBAAsB;EACtB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":[".v-avatar {\n  flex: none;\n  align-items: center;\n  display: inline-flex;\n  justify-content: center;\n  line-height: normal;\n  overflow: hidden;\n  position: relative;\n  text-align: center;\n  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transition-property: width, height;\n  vertical-align: middle;\n}\n.v-avatar.v-avatar--size-x-small {\n  --v-avatar-height: 24px;\n}\n.v-avatar.v-avatar--size-small {\n  --v-avatar-height: 32px;\n}\n.v-avatar.v-avatar--size-default {\n  --v-avatar-height: 40px;\n}\n.v-avatar.v-avatar--size-large {\n  --v-avatar-height: 48px;\n}\n.v-avatar.v-avatar--size-x-large {\n  --v-avatar-height: 56px;\n}\n.v-avatar.v-avatar--density-default {\n  height: calc(var(--v-avatar-height) + 0px);\n  width: calc(var(--v-avatar-height) + 0px);\n}\n.v-avatar.v-avatar--density-comfortable {\n  height: calc(var(--v-avatar-height) + -4px);\n  width: calc(var(--v-avatar-height) + -4px);\n}\n.v-avatar.v-avatar--density-compact {\n  height: calc(var(--v-avatar-height) + -8px);\n  width: calc(var(--v-avatar-height) + -8px);\n}\n.v-avatar {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: 0;\n}\n.v-avatar--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-avatar {\n  border-radius: 50%;\n}\n.v-avatar--variant-plain, .v-avatar--variant-outlined, .v-avatar--variant-text, .v-avatar--variant-tonal {\n  background: transparent;\n  color: inherit;\n}\n.v-avatar--variant-plain {\n  opacity: 0.62;\n}\n.v-avatar--variant-plain:focus, .v-avatar--variant-plain:hover {\n  opacity: 1;\n}\n.v-avatar--variant-plain .v-avatar__overlay {\n  display: none;\n}\n.v-avatar--variant-elevated, .v-avatar--variant-flat {\n  background: rgb(var(--v-theme-surface));\n  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));\n}\n.v-avatar--variant-elevated {\n  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-avatar--variant-flat {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-avatar--variant-outlined {\n  border: thin solid currentColor;\n}\n.v-avatar--variant-text .v-avatar__overlay {\n  background: currentColor;\n}\n.v-avatar--variant-tonal .v-avatar__underlay {\n  background: currentColor;\n  opacity: var(--v-activated-opacity);\n  border-radius: inherit;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n}\n.v-avatar .v-avatar__underlay {\n  position: absolute;\n}\n.v-avatar--rounded {\n  border-radius: 4px;\n}\n.v-avatar--start {\n  margin-inline-end: 8px;\n}\n.v-avatar--end {\n  margin-inline-start: 8px;\n}\n.v-avatar .v-img {\n  height: 100%;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
